/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, Dispatch, SetStateAction } from "react";

export interface LocalizationContextInterface {
      
        setI18nConfig:Dispatch<SetStateAction<any>>,
        getTranslation:any,
        getUserLanguage:any,
        saveUserLanguage:Dispatch<SetStateAction<any>>
}
const defaultState = {
  getTranslation:  async () => {},
  setI18nConfig: async () => { },
  getUserLanguage:  async () => {return 'en'},
  saveUserLanguage: async () => { }
} as LocalizationContextInterface

export const LocalizationContext = createContext<LocalizationContextInterface>(defaultState);
